import Vue from 'vue';
import $ from 'jquery';
import axios from 'axios';

export default Vue.component('statement-questions', {
    data: () => ({
        axe: axios.create({
            baseURL: '/mywecycle/statement'
        }),
        loading: false,
        loaded: false,
        selectedQuestions: [],
        availableQuestions: [],
        previouslySubmitted: false,
        isZeroStatement: false,
        questionTypes: {
            open: 0,
            radio: 1,
            checkbox: 2
        }
    }),
    created() {
        const _self = this;
            
        // Get questions on created for forecast statements
        _self.getQuestions();

        document.addEventListener('statement-step-4-loaded', function() {
            _self.validateZeroStatement();
            // Bind click event to open modal
            $('#step-4').on('click', 'button[data-target="#modal-statement-questions"]', function() {
                // Get questions async when step 4 is loaded and questions aren't loaded yet
                _self.getQuestions();
            });
        });
    },
    mounted() {
        this.toggleSubmitBtn(!this.previouslySubmitted);
    },
    methods: {
        getQuestions() {
            if (this.availableQuestions.length === 0) {
                this.axe.get('/GetQuestions', { params: { 
                    statementId: this.statementId
                }}).then((response) => {
    
                    // Set if answers were previously submitted
                    this.previouslySubmitted = response.data.previouslySubmitted;
    
                    // Set all available questions
                    this.availableQuestions = response.data.questions.map(q => {
                        
                        // Change list to string when type is open or radio
                        if (q.type == this.questionTypes.open || q.type == this.questionTypes.radio) {
                            q.answers = q.answers.toString();
                        }

                        return q;
                    });

                    if (this.previouslySubmitted) {
                        // Immediately set all previously answered questions
                        this.selectedQuestions = this.availableQuestions.filter(q => Array.isArray(q.answers) ? q.answers.length > 0 : q.answers != '');
                    } else {
                        // Set visible questions to first questions
                        this.selectedQuestions.push({...this.availableQuestions[0]});
                    }
                });
            }
        },
        postQuestions() {
            this.loading = true;

            let questions = this.selectedQuestions.map(q => {

                // Use spread so original item stays unchanged
                let question = {...q};
                
                // Split back strings in arrays
                if (!Array.isArray(question.answers)) question.answers = question.answers.split();
                
                return question;
            });

            this.axe.post('/PostQuestions', { statementId: this.statementId, questions: questions })
            .then((response) => {
               
                // Show success / error message
                One.helpers('notify', { ...response.data.notification, message: response.data.notification.content });
                
                if (!response.data.hasErrors) {

                    // Close modal
                    window.$('#modal-statement-questions').modal('hide');
                    
                    // Update previously submitted bool
                    this.previouslySubmitted = true;
                }
            })
            .finally(() => {
                this.loading = false;
            });;
        },
        getNextQuestion(previousQuestion) {
            let nextQuestionId;

            // Get next question id based on previous question
            if (previousQuestion.options && previousQuestion.options.map(function(o) { return o.nextQuestion }).some(x => x)) {
                // First check on answer level
                nextQuestionId = previousQuestion.options.find(a => a.id === previousQuestion.answers).nextQuestion;
            } else {
                // Otherwise get it directly from the question itself
                nextQuestionId = previousQuestion.nextQuestion;
            }

            let nextQuestion = {...this.availableQuestions.find(q => q.id === nextQuestionId)};

            // Check if there's a next question to add and that question wasn't added before
            if (nextQuestion && !this.selectedQuestions.map(function(q) { return q.id; }).includes(nextQuestionId)) {
                
                // Clear existing answers
                if (nextQuestion.type == this.questionTypes.open || nextQuestion.type == this.questionTypes.radio) {
                    nextQuestion.answers = '';
                } else {
                    nextQuestion.answers = [];
                }
                
                return nextQuestion;
            }

            return null;
        },
        validateQuestion(currentQuestion) {

            // Only trigger next question when answer is valid
            if (currentQuestion.required ? currentQuestion.answers && currentQuestion.answers != '' && Array.isArray(currentQuestion.answers) ? currentQuestion.answers.length > 0 : currentQuestion.answers.length > 4 : true) {
                let question,
                    currentQuestionIndex = this.selectedQuestions.map(function(q) { return q.id; }).indexOf(currentQuestion.id);

                // Check if it's the last question that's being answered
                if (currentQuestionIndex < (this.selectedQuestions.length - 1)) {

                    // Reset / remove all questions after question that was changed
                    this.selectedQuestions.splice(currentQuestionIndex + 1);
                    question = this.selectedQuestions[this.selectedQuestions.length - 1];
                } else {
                    question = currentQuestion;
                }

                const nextQuestion = this.getNextQuestion(question);
                if (nextQuestion) {

                    // Push new question to become visible
                    this.selectedQuestions.push(nextQuestion);

                    // If the next question isn't required, immediately check if there's another question to load
                    if (!nextQuestion.required) {

                        const secondNextQuestion = this.getNextQuestion(nextQuestion);
                        
                        // Push second next question to become visible
                        if (secondNextQuestion) this.selectedQuestions.push(secondNextQuestion);
                    }
                }
            }
        },
        toggleSubmitBtn(value) {
            // Disable / enable submit button of forecast statement based on previously submitted
            $('#step-4 button[data-target="#modal-submit-statement"]').prop('disabled', value);
        },
        validateZeroStatement(){
            this.axe.post('/IsZeroStatement', { statementId: this.statementId }).then((response) => {
                this.isZeroStatement = response.data;
            });
        }
    },
    watch: {
        previouslySubmitted: function(value) {
            this.toggleSubmitBtn(!value);
        },
    }
});